export function scrollCards() {
  const cards = document.querySelectorAll('.wp-block-scroll-cards');

  if (!cards.length) return;

  const checkOverlapping = () => {
    cards.forEach((card) => {
      const inner = card.querySelector('.wp-block-scroll-cards__inner');
      const cardWrappers = inner.querySelectorAll('.wrapper');

      // check if card is overlapping with the next card
      cardWrappers.forEach((cardWrapper, i) => {
        const nextCard = cardWrappers[i + 1];
        if (nextCard) {
          const cardRect = cardWrapper.getBoundingClientRect();
          const nextCardRect = nextCard.getBoundingClientRect();

          if (cardRect.bottom > nextCardRect.top) {
            cardWrapper.classList.add('is-overlapping');
          } else {
            cardWrapper.classList.remove('is-overlapping');
          }
        }
      });
    });
  };

  window.addEventListener('scroll', checkOverlapping);
  checkOverlapping();
}
